<template>
    <div class="home" v-loading="loading">
        <div class="header">
            <!-- 搜索区域 -->
            <div class="search">
                <el-table :data="tableData" border style="width: 100%; cursor: pointer" :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                }">
                    <el-table-column label="名称">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="最后编辑id名称">
                        <template slot-scope="scope">
                            <span style="margin-left: 10px">{{ scope.row.admin_name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="198">
                        <template slot-scope="scope">
                            <div class="table-operation" @click="compileBtn(scope.row)">
                                编辑
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!--编辑弹出框-->
        <div class="addBlock">
            <el-dialog :visible.sync="compileDialogVisible" width="444px" style="margin-top: 5vh" @close="editClose" >
                <span slot="footer" class="dialog-footer">
                    <div class="addBlock-div">
                        <div class="addBlock-div-top">
                            <div class="addBlock-div-top-title">添加</div>
                            <img class="addBlock-div-top-close" src="../../assets/common/close.png" @click="editClose" />
                        </div>

                        <div class="addBlock-div-error" v-if="compileError == true">
                            <div class="addBlock-div-error-text">
                                抱歉，标题和内容不能为空！
                            </div>
                        </div>

                        <div class="addBlock-div-center">
                            <div class="center-header">
                                <div class="center-header-title">标题</div>
                                <div class="center-header-input">
                                    <el-input placeholder="请输入标题" v-model="compileTitle" clearable></el-input>
                                </div>
                            </div>

                            <div class="center-conversion">
                                <div class="center-conversion-title">内容</div>
                                <div class="center-conversion-input">
                                    <vue-tinymce v-model="compileContent" :setting="setting" />
                                </div>
                            </div>
                        </div>

                        <div class="addBlock-div-button">
                            <!-- <div class="addBlock-div-button-left" @click="editClose">
                重 置
              </div> -->
                            <div class="addBlock-div-button-right" @click="editConfirm">
                                确 定
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getagreement,
    postagreementAdd,
    getagreementDetail,
} from '../../api/common'

export default {
    comments() { },
    data() {
        return {
            // 编辑 弹出框  是否开启
            compileDialogVisible: false,
            // 编辑 弹出框 标题
            compileTitle: '',
            //  编辑 弹出框 错误
            compileError: false,
            // 编辑  富文本编译器
            compileContent: '',
            // 编辑  富文本编译器id
            compileId: '',
            setting: {
                menubar: false,
                toolbar:
                    'undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |',
                toolbar_drawer: 'sliding',
                quickbars_selection_toolbar:
                    'removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor',
                plugins: 'link image media table lists fullscreen quickbars',
                language: 'zh_CN',
                // height: this.compileError == false ? '2.8125rem' : '2.99625rem',
                statusbar: false,
            },
            /* end */
            tableData: [],
            // 刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            basicFunShow: false,
        }
    },
    created() {
        // 获取关于我们详情
        this.loading = true
        this.getagreementClick()

        setTimeout(() => {
            this.basicFunShow = this.$store.state.pageFunctionShow
        }, 1000);
    },
    methods: {
        // 获取关于我们详情
        getagreementClick() {
            let params = {}

            getagreement(params).then((res) => {
                if (res.resultStatus == true) {
                    // 获取数据
                    this.tableData = res.resultData
                    this.loading = false
                }
            })
        },

        // 编辑弹出框 开启
        compileBtn(item) {
            if (this.basicFunShow == false) {
                return
            }

            let params = item.id
            getagreementDetail(params).then((res) => {
                if (res.resultStatus == true) {
                    this.compileTitle = res.resultData.name
                    this.compileContent = res.resultData.content
                    this.compileId = res.resultData.id
                    this.compileDialogVisible = true
                }
            })
        },
        // 编辑弹出框 确认
        editConfirm() {
            if (this.compileTitle != '' && this.compileContent != '') {
                let params = {
                    name: this.compileTitle, // 通知标题
                    content: this.compileContent, // 通知内容
                    id: this.compileId, // id
                }

                postagreementAdd(params).then((res) => {
                    if (res.resultStatus == true) {
                        this.$message({
                            message: '添加成功！',
                            type: 'success',
                        })

                        this.loading = true
                        this.compileDialogVisible = false
                        this.getagreementClick()
                    } else {
                        this.compileError = true
                    }
                })
            } else {
                this.compileError = true
            }
        },
        // 编辑弹出框 重置
        editClose() {
            this.compileTitle = ''
            this.compileContent = ''
            this.compileId = ''
            this.compileDialogVisible = false
        },
    },
}
</script>



<style>
/* 在el-dialog中tinymce z-index 被太小而被遮挡时要加这两句 */
.tox-tinymce-aux {
    z-index: 99999 !important;
}

.tinymce.ui.FloatPanel {
    z-Index: 99;
}
</style>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.home {
    margin: 0 auto;
    background-color: #f4f5f9;
}

.header {
    min-height: 900px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
}

.search {
    padding: 24px;
    box-sizing: border-box;

    /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
    }

    /deep/ .el-table .el-table__cell {
        vertical-align: top;
    }

    /deep/ .el-table tr {
        height: 46px;
    }

    /deep/ .el-table__empty-text {
        line-height: 0;
    }

    .table-operation {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2aa4ff;
        text-decoration: underline;
    }
}

/* 添加弹出框 */
.addBlock {
    /deep/ .el-dialog {
        height: var(--height) !important;
        border-radius: 10px !important;
    }

    /deep/ .el-dialog__footer {
        padding: 0;
        text-align: left;
    }

    .addBlock-div {
        .addBlock-div-top {
            display: flex;
            height: 56px;
            align-items: center;
            justify-content: space-between;
            padding: 0 24px;
            box-sizing: border-box;
            border-bottom: 1px solid #e9edf4;

            .addBlock-div-top-title {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #222222;
            }

            .addBlock-div-top-close {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }

        .addBlock-div-error {
            display: flex;
            height: 30px;
            align-items: center;
            padding: 0 24px;
            box-sizing: border-box;
            background: rgba(249, 182, 60, 0.1);

            .addBlock-div-error-text {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ed6d1f;
            }
        }

        .addBlock-div-center {
            padding: 20px 24px 21px;
            box-sizing: border-box;

            .center-header {
                .center-header-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                .center-header-input {
                    height: 32px;
                    background: #ffffff;
                    border-radius: 5px;
                    margin-top: 4px;

                    /deep/ .el-input {
                        height: 32px;
                    }

                    /deep/ .el-input__inner {
                        padding: 0 10px;
                        box-sizing: border-box;
                        height: 32px;
                        background-color: rgba(255, 255, 255, 0);
                    }
                }
            }

            .center-conversion {
                margin-top: 14px;

                .center-conversion-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                .center-conversion-input {
                    background: #ffffff;
                    border-radius: 5px;
                    margin-top: 4px;
                    //   min-height: 300px;
                }
            }
        }

        .addBlock-div-button {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 24px;
            box-sizing: border-box;
            height: 52px;
            border-top: 1px solid #e9edf4;

            .addBlock-div-button-left,
            .addBlock-div-button-right {
                width: 65px;
                height: 32px;
                background: #ffffff;
                border-radius: 10px;
                border: 1px solid #e9edf4;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }

            .addBlock-div-button-right {
                background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                margin-left: 8px;
                color: #ffffff;
            }
        }
    }
}
</style>
